"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const hauler_manager_types_1 = require("./hauler-manager.types");
const app_types_1 = require("pages/app.types");
const initialState = {
    isLoading: true,
    isError: false,
    isSuccess: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    dataCheckpoint: [],
    dataDriver: [],
    dataHauler: [],
    dataVessel1: [],
    dataVessel2: [],
    dataContractor: [],
    mutationMode: false,
    dataDropdownVessel1: [],
    dataDropdownVessel2: [],
    dataItem: {
        id: '0',
        driver: '',
        driver_id: '',
        hauler_no: '',
        hauler_id: '',
        vessel_no_1: '',
        vessel_no_2: '',
        vessel_id_1: '',
        vessel_id_2: '',
        contractor_id: '',
        contractor_name: '',
        checkpoint_id: '',
        checkpoint_name: '',
        vessel_capacity_1: 0,
        vessel_capacity_2: 0,
        created_by: '',
        created_date: new Date(),
        modified_by: '',
        modified_date: new Date(),
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'modified_date', dir: 'desc' }],
    },
    dataStatesCheckpoint: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10000,
        total: 0,
        sort: [{ field: 'silo', dir: 'asc' }],
        filter: {
            logic: 'and',
            filters: [
                { field: 'is_active', operator: 'eq', value: true },
            ],
        },
    },
};
const haulerManagerReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [hauler_manager_types_1.haulerManagerTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [hauler_manager_types_1.haulerManagerTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [hauler_manager_types_1.haulerManagerTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess } = action.payload;
        const dataDropdownVessel1 = state.dataVessel1.filter((item) => {
            return item.vessel_no !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.vessel_no_2);
        });
        const dataDropdownVessel2 = state.dataVessel2.filter((item) => {
            return item.vessel_no !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.vessel_no_1);
        });
        const isMutationFalse = mutationMode === 'close' || mutationMode === false;
        return Object.assign(Object.assign({}, state), { mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess, dataHauler: isMutationFalse
                ? initialState.dataHauler
                : state.dataHauler, dataDriver: isMutationFalse
                ? initialState.dataDriver
                : state.dataDriver, dataVessel1: isMutationFalse
                ? initialState.dataVessel1
                : state.dataVessel1, dataVessel2: isMutationFalse
                ? initialState.dataVessel2
                : state.dataVessel2, dataDropdownVessel1: isMutationFalse
                ? initialState.dataDropdownVessel1
                : dataDropdownVessel1, dataDropdownVessel2: isMutationFalse
                ? initialState.dataDropdownVessel2
                : dataDropdownVessel2 });
    },
    [hauler_manager_types_1.haulerManagerTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.map((item) => {
                if (item.id === (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id))
                    return dataItem;
                return item;
            }) });
    },
    [hauler_manager_types_1.haulerManagerTypes.ON_DELETE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.filter((item) => item.id !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id)) });
    },
    [hauler_manager_types_1.haulerManagerTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [hauler_manager_types_1.haulerManagerTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { sort: action.payload }) });
    },
    [hauler_manager_types_1.haulerManagerTypes.SET_ERROR]: (state, action) => {
        return Object.assign(Object.assign(Object.assign({}, state), action.payload), { isLoading: false, isSuccess: false });
    },
    [hauler_manager_types_1.haulerManagerTypes.SET_LOADING]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: action.payload });
    },
    [hauler_manager_types_1.haulerManagerTypes.SET_DATA_DRIVER]: (state, action) => {
        const driver_data = action.payload.dataDriver.find((item) => item.driver === state.dataItem.driver) || {
            id: '',
            driver: '',
            driver_type: '',
            is_active: true,
            contractor: '',
            contractor_code: '',
            contractor_name: '',
            created_by: '',
            created_date: new Date(),
            modified_by: '',
            modified_date: new Date(),
        };
        const newDataItem = Object.assign(Object.assign({}, state.dataItem), { driver_data, driver: driver_data.id });
        return Object.assign(Object.assign({}, state), { dataItem: newDataItem, dataDriver: action.payload.dataDriver });
    },
    [hauler_manager_types_1.haulerManagerTypes.SET_DATA_CHECKPOINT]: (state, action) => {
        const checkpoint_data = action.payload.dataSilo.find((item) => item.checkpoint_name === state.dataItem.checkpoint_name) || {
            checkpoint_id: '',
            checkpoint_name: '',
            created_by: '',
            is_active: true,
            description: '',
            modified_by: '',
            target_lead_time: '',
            target_queue_time: '',
            created_date: new Date(),
            modified_date: new Date(),
            target_lead_time_display: '',
            target_queue_time_display: '',
        };
        const newDataItem = Object.assign(Object.assign({}, state.dataItem), { checkpoint_data, checkpoint_name: checkpoint_data.checkpoint_name, checkpoint_id: checkpoint_data.checkpoint_id });
        return Object.assign(Object.assign({}, state), { dataItem: newDataItem, dataCheckpoint: action.payload.dataSilo });
    },
    [hauler_manager_types_1.haulerManagerTypes.SET_DATA_VESSEL_1]: (state, action) => {
        const { dataVessel1 } = action.payload;
        const vessel_default = {
            id: '',
            contractor_id: '',
            contractor_code: '',
            contractor_name: '',
            contractor: {
                id: '',
                contractor_code: '',
                contractor_name: '',
            },
            vessel_no: '',
            vessel_capacity: 0,
            is_active: {
                value: true,
                status: 'Active',
            },
            created_by: '',
            created_date: new Date(),
            modified_by: '',
            modified_date: new Date(),
        };
        const vessel_data1 = dataVessel1.find((item) => item.vessel_no === state.dataItem.vessel_no_1) || vessel_default;
        const newDataItem = Object.assign(Object.assign({}, state.dataItem), { vessel_data1, vessel_no_1: vessel_data1.vessel_no });
        const dataDropdownVessel1 = dataVessel1.filter((item) => {
            return item.vessel_no !== state.dataItem.vessel_no_2;
        });
        return Object.assign(Object.assign({}, state), { dataItem: newDataItem, dataVessel1: dataVessel1, dataDropdownVessel1: state.mutationMode === 'add' ? dataDropdownVessel1 : dataVessel1 });
    },
    [hauler_manager_types_1.haulerManagerTypes.SET_DATA_VESSEL_2]: (state, action) => {
        const { dataVessel2 } = action.payload;
        const vessel_default = {
            id: '',
            contractor_id: '',
            contractor_code: '',
            contractor_name: '',
            contractor: {
                id: '',
                contractor_code: '',
                contractor_name: '',
            },
            vessel_no: '',
            vessel_capacity: 0,
            is_active: {
                value: true,
                status: 'Active',
            },
            created_by: '',
            created_date: new Date(),
            modified_by: '',
            modified_date: new Date(),
        };
        const vessel_data2 = dataVessel2.find((item) => item.vessel_no === state.dataItem.vessel_no_2) || vessel_default;
        const newDataItem = Object.assign(Object.assign({}, state.dataItem), { vessel_data2, vessel_no_2: vessel_data2.vessel_no });
        const dataDropdownVessel2 = dataVessel2.filter((item) => {
            return item.vessel_no !== state.dataItem.vessel_no_1;
        });
        return Object.assign(Object.assign({}, state), { dataItem: newDataItem, dataVessel2: dataVessel2, dataDropdownVessel2: state.mutationMode === 'add' ? dataDropdownVessel2 : dataVessel2 });
    },
    [hauler_manager_types_1.haulerManagerTypes.SET_DATA_HAULER]: (state, action) => {
        const hauler_data = action.payload.dataHauler.find((item) => item.hauler_no === state.dataItem.hauler_no) || {
            id: '',
            contractor_id: '',
            contractor_name: '',
            contractor: {
                id: '',
                contractor_code: '',
                contractor_name: '',
                contractor_type: '',
                is_active: {
                    status: 'Active',
                    value: true,
                },
                modified_by: '',
                modified_date: new Date(),
                created_by: '',
                created_date: new Date(),
            },
            hauler_no: '',
            is_active: {
                value: true,
                status: 'Active',
            },
            modified_by: '',
            modified_date: new Date(),
            created_by: '',
            created_date: new Date(),
            rfid_tag: ''
        };
        const newDataItem = Object.assign(Object.assign({}, state.dataItem), { hauler_data, hauler_no: hauler_data.hauler_no });
        return Object.assign(Object.assign({}, state), { dataItem: newDataItem, dataHauler: action.payload.dataHauler });
    },
    [hauler_manager_types_1.haulerManagerTypes.SET_DATA_CONTRACTOR]: (state, action) => {
        const contractor_data = action.payload.find((x) => x.contractor_name === state.dataItem.contractor_name) || {
            id: '',
            contractor_code: '',
            contractor_name: '',
            contractor_type: '',
            is_active: {
                status: 'Active',
                value: true,
            },
            modified_by: '',
            modified_date: new Date(),
            created_by: '',
            created_date: new Date(),
        };
        const newDataItem = Object.assign(Object.assign({}, state.dataItem), { contractor_data, contractor_name: contractor_data.contractor_name });
        return Object.assign(Object.assign({}, state), { dataContractor: action.payload, dataItem: newDataItem });
    },
});
exports.default = haulerManagerReducer;
